class WiggensbachCollectionOverview extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('[data-wig-collections-viewport]');
    this.slides = Array.from(this.querySelectorAll('[data-wig-collections-slide]'));
    this.previousButton = this.querySelector('[data-wig-collections-prev]');
    this.nextButton = this.querySelector('[data-wig-collections-next]');
    this.dots = Array.from(this.querySelectorAll('[data-wig-collections-dot]'));

    if (!this.viewport || this.slides.length < 2) return;

    this.onScroll = this.update.bind(this);
    this.onResize = this.update.bind(this);
    this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);

    if (this.previousButton) {
      this.previousButton.addEventListener('click', () => this.goTo(this.currentIndex - 1));
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.goTo(this.currentIndex + 1));
    }

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goTo(index));
    });

    this.update();
  }

  disconnectedCallback() {
    if (this.viewport && this.onScroll) {
      this.viewport.removeEventListener('scroll', this.onScroll);
    }

    if (this.onResize) {
      window.removeEventListener('resize', this.onResize);
    }
  }

  get currentIndex() {
    if (!this.viewport || this.slides.length === 0) return 0;

    const viewportCenter = this.viewport.scrollLeft + this.viewport.clientWidth / 2;
    let closestIndex = 0;
    let closestDistance = Number.POSITIVE_INFINITY;

    this.slides.forEach((slide, index) => {
      const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
      const distance = Math.abs(slideCenter - viewportCenter);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  goTo(index) {
    const targetIndex = Math.max(0, Math.min(index, this.slides.length - 1));
    const targetSlide = this.slides[targetIndex];

    if (!targetSlide) return;

    targetSlide.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center'
    });
  }

  update() {
    const index = this.currentIndex;

    this.dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === index;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    if (this.previousButton) {
      this.previousButton.disabled = index === 0;
    }

    if (this.nextButton) {
      this.nextButton.disabled = index >= this.slides.length - 1;
    }
  }
}

if (!customElements.get('wiggensbach-collection-overview')) {
  customElements.define('wiggensbach-collection-overview', WiggensbachCollectionOverview);
}
